import { Repository } from "src/firebase/firestore/repository";
import { Reward } from "../types/reward.entity";

export class RewardsRepository extends Repository<Reward> {
  constructor() {
    super("rewards");
  }
}
export const rewardsRepository = new RewardsRepository();
